import { useTranslate } from "@similarweb/i18n-provider";
import { DropdownButton } from "@similarweb/ui-components";

import type { TriggerRenderProps } from "app/pages/digital-marketing/keywords-campaigns/reports/page-filters/tags";

export const TagsDropdownTrigger = ({ buttonText, disabled }: TriggerRenderProps) => {
    const { translate } = useTranslate();
    if (buttonText) {
        return <DropdownButton hasValue>{buttonText}</DropdownButton>;
    }
    return <DropdownButton disabled={disabled}>{translate("home.dashboards.wizard.tags.button.text")}</DropdownButton>;
};
